import React from 'react';
import { motion } from 'framer-motion';
import { FaGraduationCap, FaCalendar, FaUniversity, FaStar } from 'react-icons/fa';

const Education = () => {
  return (
    <section className="education section" id="education">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="section-title">Education</h2>
          <p className="section-subtitle">Academic background and achievements</p>
        </motion.div>

        <motion.div
          className="education-card"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          viewport={{ once: true }}
        >
          <div className="education-header">
            <div className="university-logo">
              <FaGraduationCap />
            </div>
            <div className="education-info">
              <h3>Bachelor of Science in Software Engineering</h3>
              <h4>
                <FaUniversity /> University of Management and Technology
              </h4>
              <div className="education-meta">
                <span>
                  <FaCalendar /> 2019 - 2023
                </span>
                <span>
                  <FaStar /> GPA: 3.2/4.0
                </span>
              </div>
            </div>
          </div>

          <div className="education-details">
            <div className="coursework">
              <h4>Relevant Coursework:</h4>
              <div className="course-grid">
                {[
                  'Data Structures & Algorithms',
                  'Database Systems (SQL/NoSQL)',
                  'Full-Stack Web Development',
                  'Software Engineering',
                  'Artificial Intelligence',
                  'Object-Oriented Programming',
                  'Computer Networks',
                  'Operating Systems',
                  'Software Design Patterns',
                  'Mobile App Development',
                  'Cloud Computing',
                  'Cybersecurity Fundamentals',
                ].map((course, index) => (
                  <motion.div
                    key={index}
                    className="course-item"
                    initial={{ opacity: 0, scale: 0.9 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.3, delay: index * 0.05 }}
                    viewport={{ once: true }}
                  >
                    {course}
                  </motion.div>
                ))}
              </div>
            </div>

            <div className="capstone">
              <h4>Capstone Project:</h4>
              <div className="capstone-card">
                <h5>Full-Stack Social Media Platform</h5>
                <p>
                  Developed a comprehensive social media platform using the MERN stack featuring real-time
                  notifications powered by Socket.io, AI-based content recommendations, user authentication,
                  image uploads, and a responsive design. The project demonstrated advanced full-stack
                  development skills and integration of modern web technologies.
                </p>
                <div className="capstone-tech">
                  {['MongoDB', 'Express.js', 'React.js', 'Node.js', 'Socket.io', 'AI/ML', 'JWT', 'AWS S3'].map(
                    (tech, index) => (
                      <span key={index} className="tech-tag">
                        {tech}
                      </span>
                    )
                  )}
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Education;